<template>
  <PopupBox
    :disable="isDisabled"
    :popup-styles="{ top: 3 }"
    class="period-filter-wrapper"
    placement="bottom-end"
    @visibility-change="handlePopupVisibilityChange"
  >
    <template v-slot:trigger>
      <h2 :class="clsx('period-filter', { 'period-filter--active' : hasActiveFilters, 'period-filter--disabled': isDisabled })">
        <slot />
        <PopupToggler
          class="ml-2"
          :is-disabled="isDisabled"
          :is-active="hasActiveFilters"
          :is-open="popupVisible"
        />
      </h2>
    </template>
    <template>
      <PopupMenuWithCalendar
        class="period-filter-calendar"
        :menu-items="menuItems"
        :menu-selected-item="menuSelectedItem"
        :calendar-mode="calendarMode"
        :calendar-value="calendarValue"
        :calendar-is-range="calendarIsRange"
        :calendar-events="calendarEvents"
        :calendar-holidays="calendarHolidays"
        :calendar-disabled-dates="calendarDisabledDates"
        :calendar-start-year="calendarStartYear"
        :calendar-end-year="calendarEndYear"
        :calendar-max-range-days="calendarMaxRangeDays"
        :calendar-max-range-weeks="calendarMaxRangeWeeks"
        :calendar-max-range-months="calendarMaxRangeMonths"
        :options="options"
      />
    </template>
  </PopupBox>
</template>

<script>
import { clsx } from 'clsx';
import moment from 'moment';
import { PopupBox, PopupMenuWithCalendar, popupToggle, PopupToggler } from '@/shared/ui/popup';

export default {
  props: {
    isDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    menuItems: {
      type: Array,
      required: true,
    },
    menuSelectedItem: {
      type: Object,
      required: false,
      default: () => {},
    },
    calendarMode: {
      type: String,
      default: 'days',
      validator: (value) => ['days', 'weeks', 'months'].includes(value),
    },
    calendarValue: {
      type: [String, Date, Object, Array],
      default: null,
    },
    calendarIsRange: {
      type: Boolean,
      default: false,
    },
    calendarEvents: {
      type: Array,
      default: () => [],
      validator: (value) => value.every((item) => {
        return item && (typeof item === 'string' || item instanceof Date || (typeof item === 'object' && item.date));
      }),
    },
    calendarHolidays: {
      type: Array,
      default: () => [],
      validator: (value) => value.every((item) => {
        return item && (typeof item === 'string' || item instanceof Date || (typeof item === 'object' && item.date));
      }),
    },
    calendarDisabledDates: {
      type: Array,
      default: () => [],
      validator: (value) => value.every((item) => {
        return item && (typeof item === 'string' || item instanceof Date || (typeof item === 'object' && item.date));
      }),
    },
    calendarStartYear: {
      type: Number,
      default: null,
    },
    calendarEndYear: {
      type: Number,
      default: null,
    },
    calendarSelectedPeriod: {
      type: Object,
      default: () => {},
    },
    calendarMaxRangeDays: {
      type: Number,
      default: null,
      validator: (value) => value >= 0,
    },
    calendarMaxRangeWeeks: {
      type: Number,
      default: null,
      validator: (value) => value >= 0,
    },
    calendarMaxRangeMonths: {
      type: Number,
      default: null,
      validator: (value) => value >= 0,
    },
    options: {
      type: Object,
      default: () => {},
    },
  },
  mixins: [ popupToggle ],
  components: { PopupBox, PopupToggler, PopupMenuWithCalendar },
  computed: {
    hasActiveFilters() {
      return this.calendarIsRange ? !!(this.calendarSelectedPeriod?.startDate && moment(this.calendarSelectedPeriod?.startDate).isValid()
        && this.calendarSelectedPeriod?.endDate && moment(this.calendarSelectedPeriod?.endDate).isValid()) : !!this.calendarSelectedPeriod?.date;
    },
  },
  methods: { clsx },
};
</script>

<style lang="scss" scoped>
.period-filter {
  font-size: 16px;
  font-weight: 400;
  cursor: pointer;

  &-wrapper {
    display: inline-block;
  };

  &--active {
    color: #FB923C;
  }

  &--disabled {
    cursor: not-allowed;
    color: #6B7280;
  }

  &-calendar {
    padding: 16px;
  }
}
</style>
